import React, { useEffect, useRef } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';

interface MapZoomControlProps {
  children?: React.ReactNode;
}

export const MapZoomControl: React.FC<MapZoomControlProps> = ({ children }) => {
  const map = useMap();
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (ref.current) {
      L.DomEvent.disableClickPropagation(ref.current);
      L.DomEvent.disableScrollPropagation(ref.current);
    }
  }, []);

  const handleZoomIn = () => map.zoomIn();
  const handleZoomOut = () => map.zoomOut();

  return (
    <div
      ref={ref}
      className="absolute right-4 z-[1000] flex items-center h-[44px] md:h-[36px]"
      // Add the iOS safe-area inset to the 16 px offset so the corner-
      // control stack sits below any notch / dynamic island on devices
      // that have one (Add-to-Home-Screen PWA / standalone mode). Falls
      // back to 0 on devices without an inset, leaving the desktop
      // 16 px-from-top behaviour unchanged.
      style={{
        top: 'calc(env(safe-area-inset-top, 0px) + 16px)',
        pointerEvents: 'auto',
      }}
    >
      {children}

      {/* Zoom buttons — bumped to 44 px on mobile to clear the iOS 44 pt
          touch-target floor. md+ keeps the historical 31×36 chrome. */}
      <button
        onClick={handleZoomIn}
        className="w-[40px] md:w-[31px] h-full bg-figma-card border-r border-figma-panel/50 flex items-center justify-center hover:bg-figma-panel active:bg-figma-panel transition-smooth"
        title="Zoom in"
        aria-label="Zoom in"
      >
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
          <path d="M5.5 1.5V9.5" stroke="#c1f04f" strokeWidth="1.5" />
          <path d="M1 5.5H10" stroke="#c1f04f" strokeWidth="1.5" />
        </svg>
      </button>

      <button
        onClick={handleZoomOut}
        className="w-[40px] md:w-[31px] h-full bg-figma-card rounded-r-[10px] flex items-center justify-center hover:bg-figma-panel active:bg-figma-panel transition-smooth"
        title="Zoom out"
        aria-label="Zoom out"
      >
        <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
          <path d="M1 5.5H10" stroke="#c1f04f" strokeWidth="1.5" />
        </svg>
      </button>
    </div>
  );
};
